import React, { Component } from 'react';
import 'rc-slider/assets/index.css';
import 'rc-tooltip/assets/bootstrap.css';
import { Range } from 'rc-slider';
import './style.css';
import { HeaderQuestion, NextQuestionButton } from '../../components';
import { URL_START } from '../../constants';
import { translate, Trans } from 'react-i18next';
import { RIEInput } from 'riek';
import { withRouter } from 'react-router-dom';

class Sliderbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value ? props.value : 50,
      left: props.left,
      right: props.right
    };
    this.handleChange = this.handleChange.bind(this);
    this.changeState = this.changeState.bind(this);
    this.save = this.save.bind(this);
  }

  handleChange(value) {
    this.setState({ value: 100 - value[0] });
  }

  componentWillReceiveProps(nextProps, nextState) {
    this.setState({
      value: 'undefined' !== typeof nextProps.value ? nextProps.value : 50
    });
  }

  changeState = newState => {
    this.setState(newState);
    const state = { ...this.state, ...newState };
    const singleAspect = {
      answer: { term: state.left, opposite: state.right }
    };
    this.props.saveAspect(singleAspect, this.props.aspectId);
  };

  save(event) {
    this.props.save(
      this.state.value,
      this.props.projectObjectUuid,
      this.props.aspectId
    );
    event.preventDefault();
    if (this.props.history.canGo(1)) {
      this.props.history.goForward();
    } else {
      this.props.history.push(this.props.findNextPath());
    }
  }

  render() {
    const name = this.props.name;
    const description = (
      <Trans i18nKey="slider">
        Please use the slider to express your opinion about "{{ name }}
        ".
      </Trans>
    );

    let value = this.state.value;
    let colorButton = false;
    if (value === -999) {
      value = 50;
      colorButton = true;
    }
    return (
      <div className="card-body">
        <HeaderQuestion
          text=""
          description={description}
          skip={this.props.skip}
          colorButton={colorButton}
        />
        <div className="App-sliderbar container">
          <div className="slider-object-name">{this.props.name}</div>

          <div className="row">
            <div className="col-6 text-left">
              <RIEInput
                className="editable"
                value={this.state.left}
                propName="left"
                change={this.changeState}
              />
            </div>
            <div className="col-6 text-right">
              <RIEInput
                className="editable"
                value={this.state.right}
                propName="right"
                change={this.changeState}
              />
            </div>
          </div>
        </div>

        <div className="App-sliderbar-slider">
          <Range
            min={0}
            max={100}
            step={10}
            value={[100 - value]}
            onChange={this.handleChange}
            handleStyle={[
              {
                height: 65,
                width: 65,
                marginTop: -30,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundImage: 'url(' + this.props.image + ')',
                backgroundSize: 65
              }
            ]}
          />
          <div className="percent-values">
            <div className="percent percent--left">{value}%</div>
            <div className="percent percent--right">{100 - value}%</div>
          </div>
        </div>
        <NextQuestionButton
          to={URL_START + '/' + this.props.projectObjectUuid + '/'}
          onClick={this.save}
        />
      </div>
    );
  }
}

export default withRouter(translate('translations')(Sliderbar));



// WEBPACK FOOTER //
// ./src/comparison/components/Sliderbar/index.js